/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { useState } from 'react';
import { AuthProvider, AuthReactConfig } from '@asgardeo/auth-react';
import { ThemeProvider } from '@material-ui/core/styles';
import { IntlProvider } from 'react-intl';
import {
  asgardeoSdkConfig,
  asgardeoSdkResourceUrls,
  asgardeoSdkScopes,
} from 'config';
import CustomRouter from 'CustomRouter';
import PreLoader from 'pages/preloader/PreLoader';
import useChoreoTheme from 'theme/Theme';

export const BaseProvider: React.FC = ({ children }) => {
  const [isDarkMode] = useState<null | boolean>(false);
  const theme = useChoreoTheme(isDarkMode);
  const sdkConfig: AuthReactConfig = {
    ...asgardeoSdkConfig,
    resourceServerURLs: asgardeoSdkResourceUrls?.split('|'),
    scope: asgardeoSdkScopes?.split('|'),
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <IntlProvider locale="en" messages={{}}>
          <CustomRouter>
            <AuthProvider config={sdkConfig} fallback={<PreLoader />}>
              {children}
            </AuthProvider>
          </CustomRouter>
        </IntlProvider>
      </ThemeProvider>
    </>
  );
};

export default BaseProvider;
